import React from "react";
import {OrbitComponentWithState} from '../../base-components/orbit-component-with-state/orbit-component-with-state';
import {IModalDialogHandler} from '../../../services/dialog/dialog.service.interface';
import { ModalDialogActionsComponent } from "../../modal-dialog/modal-dialog-actions.component";
import {DialogTextBox} from "../../modal-dialog/boxes/text/dialog-text.box";
import {GeoModalWrapperBox} from '../boxes/geo-modal-wrapper.box';
import {GeoDialogListBox} from "./boxes/geo-dialog-list.box";
import {GeoDialogListItemBox} from "./boxes/geo-dialog-list-item.box";
import {GeoDialogColoredTextBox} from "./boxes/geo-dialog-colored-text.box";
import {CyClass} from "../../../../common/cy-classes";

interface IGeoInstallPluginPopupComponentProps {
    onDownloadPressed: (popUpCloseHandler:() => any) => any;
    onRestartDownloadPressed: () => any;
    dialogHandler: IModalDialogHandler;
}

interface IGeoInstallPluginPopupComponentState {
    downloadClicked:boolean;
}

export class GeoInstallPluginPopupComponent extends OrbitComponentWithState<IGeoInstallPluginPopupComponentProps, IGeoInstallPluginPopupComponentState> {
    state = {downloadClicked:false};

    private _onOkPressed = () => {
        this.services.analytics.sendOrbitUserFlowEvent('Client_Message', 'GeoInstallPluginPopupComponent', 'APPROVE');
        this.props.onDownloadPressed(() => {this._closeDialogBox()});
        this.setState({downloadClicked:true});
    };

   private _onFooterLinkPressed = () => {
        this.services.analytics.sendOrbitUserFlowEvent('Client_Message', 'GeoInstallPluginPopupComponent', 'DOWNLOAD_AGAIN');
        this.props.onRestartDownloadPressed();
    };

    private _closeDialogBox = () => {
        this.props.dialogHandler && this.props.dialogHandler.close();
    };

    render() {
        return (
            <GeoModalWrapperBox className={CyClass('cy-modal-content')}>
                {<GeoDialogColoredTextBox>{this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_1")}</GeoDialogColoredTextBox>}
                {<DialogTextBox>{this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_2")}</DialogTextBox>}
                {<DialogTextBox>{this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_3")}</DialogTextBox>}
                {<GeoDialogColoredTextBox>{this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_HEADER_4")}</GeoDialogColoredTextBox>}
                <GeoDialogListBox>
                    <GeoDialogListItemBox itemPrefix='1'>{this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_BODY_1")}</GeoDialogListItemBox>
                    <GeoDialogListItemBox itemPrefix='2'>{this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_BODY_2")}</GeoDialogListItemBox>
                    <GeoDialogListItemBox itemPrefix='3' isLast = {true}>{this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_BODY_3")}</GeoDialogListItemBox>
                </GeoDialogListBox>

                <ModalDialogActionsComponent
                    primaryAction={{
                        text: this.services.translation.translate("GEO_PLUGIN_DOWNLOAD_BUTTON"),
                        onClick: this._onOkPressed,
                        disabled:this.state.downloadClicked,
                        className: CyClass('cy-state-select-approve-button')
                    }}
                    linkAction = {{
                        text: this.state.downloadClicked?this.services.translation.translate("GEO_PLUGIN_INSTALLATION_MSG_FOOTER"):"",
                        onClick: this._onFooterLinkPressed,
                        className: CyClass('cy-modal-dialog-link')
                    }}
                />
            </GeoModalWrapperBox>
        );
    }
}
